import { taxInvoiceApi } from '@/api';
export default {
    async getTaxInvoiceById(hubId, taxInvoiceId) {
        const response = await taxInvoiceApi.getTaxInvoiceById(hubId, taxInvoiceId);
        return response.data;
    },
    async putTaxInvoiceById(hubId, taxInvoiceId, data) {
        const response = await taxInvoiceApi.putTaxInvoiceById(hubId, taxInvoiceId, data);
        return response.data;
    },
    async postTaxInvoiceToPublish(hubId, taxInvoiceId) {
        const response = await taxInvoiceApi.postTaxInvoiceToPublish(hubId, taxInvoiceId);
        return response.data;
    },
};
